



































import { Vue, Component, Prop } from 'vue-property-decorator';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import DateRange from '@shared/components/forms/inputs/date-range/date-range.vue';
import Table from '@shared/components/tables/table.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import BcAccountingReportSessionTable from '@accounting/components/tables/accounting-report/accounting-report-session-table.vue';
import BcAccountingReportSaleTable from '@accounting/components/tables/accounting-report/accounting-report-sale-table.vue';
import BcAccountingReportPaymentTable from '@accounting/components/tables/accounting-report/accounting-report-payment-table.vue';

@Component({
  name: 'bc-accounting-report-table',
  components: {
    'bc-accounting-report-session-table': BcAccountingReportSessionTable,
    'bc-accounting-report-sale-table': BcAccountingReportSaleTable,
    'bc-accounting-report-payment-table': BcAccountingReportPaymentTable,
    'bc-search-input': SearchInput,
    'bc-table-wrapper': TableWrapper,
    'bc-multi-select': MultiSelect,
    'bc-date-range': DateRange,
    'bc-table': Table,
    'bc-display-field-badge': DisplayFieldBadge,
    'bc-display-contact-link': DisplayContactLink,
    'bc-display-code': DisplayFieldCode,
  },
})
export default class AccountingReportTable extends Vue {
  // PROPS
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: String }) readonly navigationPortalTarget: string;
  @Prop({ type: Boolean, default: true }) readonly showPageActionButtons: boolean;
  @Prop({ type: Boolean, default: false }) readonly showTabs: boolean;

  // DATA PROPERTIES
  // Table options
  selectedIndexTab: number = 0;

  // Filters

  // COMPUTED PROPERTIES
  // Labels & Placeholders
  get accountingReportTabLabel(): string {
    return this.$t('global.accounting_reports.tabs.accounting_report.label').toString();
  }

  get orderItemsTabLabel(): string {
    return this.$t('global.accounting_reports.tabs.order_items.label').toString();
  }

  get paymentsTabLabel(): string {
    return this.$t('global.accounting_reports.tabs.payments.label').toString();
  }
}
